module.exports = __webpack_public_path__ + "static/media/s_bar13.6b06fb27.svg";